import "here-js-api/scripts/mapsjs-core";
import "here-js-api/scripts/mapsjs-service";

declare const H: any;

export class HereMaps {
  private appId = "EdVwfllBMIX1jNZiLIHV";
  private appCode = "Yu-Dtw6CvajFeXx3SqdaoA";
  private platform: H.service.Platform;

  constructor() {
    this.platform = new H.service.Platform({
      app_id: this.appId,
      app_code: this.appCode,
      useHTTPS: true
    });
  }

  private fetchRoute = async (
    waypoints: [number, number][]
  ): Promise<H.service.ServiceResult> => {
    const routingParams: H.service.ServiceParameters = {
      mode: "balanced;car;traffic:disabled",
      representation: "display"
    };
    waypoints.forEach((w, i) => {
      routingParams[`waypoint${i}`] = `geo!${w[0]},${w[1]}`;
    });

    const router = this.platform.getRoutingService();
    return new Promise((resolve, reject) => {
      router.calculateRoute(routingParams, resolve, reject);
    });
  };

  calculateRouteShape = async (
    waypoints: [number, number][]
  ): Promise<[number, number][]> => {
    const result = await this.fetchRoute(waypoints);
    if (result.response && result.response.route) {
      const route = result.response.route[0];
      const shape = route.shape;
      const points = shape.map(
        (p): [number, number] => [
          parseFloat(p.split(",")[1]),
          parseFloat(p.split(",")[0])
        ]
      );
      return points;
    } else {
      throw new Error("route not found");
    }
  };
}
